// Makes the header sticky on scroll/resize/load
const stickyHeader = () => {
	const header = document.querySelector('.js-front-page-header');
    const heroContainer = document.querySelector('.home-hero__container')

	if (header && heroContainer) {
        ['load', 'resize', 'scroll'].forEach((event) => {
            window.addEventListener(event, () => {
                if (window.scrollY > heroContainer.offsetHeight) {
                    header.classList.add('is-fixed');
                } else {
                    header.classList.remove('is-fixed');
                }
            });
        });
    }

	

};

stickyHeader();